import A from '../../actions/dod/dodDataActions';

const init = {
    showPasswordResetModal: false
};

export default (state=init, action) => {
    switch(action.type) {
        case A.TOGGLE_PASSWORD_RESET_MODAL: return {...state, showPasswordResetModal: !state.showPasswordResetModal };
        default: return {...state};
    }
}
